<template>
  <v-form class='createWeldingProcedureForm' v-model='valid' ref='createWeldingProcedureForm'>
    <v-container class='mb-10'>
      <v-row>
        <!-- <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.company_id'
            :error-messages='error.company_id'
            label='Company'
            placeholder='Select Company'
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col> -->
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="weldingProcedure.wptwpr_id" :options="{ url: 'welding_process', label: 'Welding Process', multiple: true, returnType: 'object' }" :errorMessage="error.wptwpr_id" :selectedData="weldingProcedure.wptwpr_id"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="weldingProcedure.pqr_id" :options="{ url: 'welding_procedure', label: 'PQR', data: {'type' : 'pqr'} }" :errorMessage="error.pqr_id" :selectedData="{id: weldingProcedure.pqr_id, text: weldingProcedure.pqr_name}"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="weldingProcedure.referred_standard_id" :options="{ url: 'referred_standard', label: 'Refrerred Standard'}" :errorMessage="error.referred_standard_id" :selectedData="{id: weldingProcedure.referred_standard_id, text: weldingProcedure.referred_standard_name}"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="weldingProcedure.joint_type_id" :options="{ url: 'joint_type', label: 'Joint Type'}" :errorMessage="error.joint_type_id" :selectedData="{id: weldingProcedure.joint_type_id, text: weldingProcedure.joint_type_name}"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="weldingProcedure.qualification_method_id" :options="{ url: 'qualification_method', label: 'Qualification Method'}" :errorMessage="error.qualification_method_id" :selectedData="{id: weldingProcedure.qualification_method_id, text: weldingProcedure.qualification_method_name}"/>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="weldingProcedure.rev_date"
            :error-messages="error.rev_date"
            type="date"
            label="Rev Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.rev_no'
            :error-messages='error.rev_no'
            label='Rev No'
            placeholder='Rev No'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-autocomplete
            v-model="weldingProcedure.type"
            :items="[ {id: 'wps', text: 'wps'}, {id: 'pqr', text: 'pqr'}]"
            :error-messages='error.type'
            label="Type"
            placeholder='Type'
          ></v-autocomplete>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.joint_backing'
            :error-messages='error.joint_backing'
            label='Joint Backing'
            placeholder='Joint Backing'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.joint_backing_material'
            :error-messages='error.joint_backing_material'
            label='Joint Backing Material'
            placeholder='Joint Backing Material'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.back_gouging'
            :error-messages='error.back_gouging'
            label='Back Gouging'
            placeholder='Back Gouging'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.back_gouging_method'
            :error-messages='error.back_gouging_method'
            label='Back Gouging Method'
            placeholder='Back Gouging Method'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.root_spacing'
            :error-messages='error.root_spacing'
            label='Root Spacing'
            placeholder='Root Spacing'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.root_face'
            :error-messages='error.root_face'
            label='Root Face'
            placeholder='Root Face'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.groove_angle'
            :error-messages='error.groove_angle'
            label='Groove Angel'
            placeholder='Groove Angel'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.radius'
            :error-messages='error.radius'
            label='Radius'
            placeholder='Radius'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.aws_classification'
            :error-messages='error.aws_classification'
            label='AWS Classification'
            placeholder='AWS Classification'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.filler_metal_diameter'
            :error-messages='error.filler_metal_diameter'
            label='Filler Metal Diameter'
            placeholder='Filler Metal Diameter'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.manufacturer_trade_name'
            :error-messages='error.manufacturer_trade_name'
            label='Manufacturer Trade Name'
            placeholder='Manufacturer Trade Name'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-textarea
            v-model="weldingProcedure.filler_metal_other"
            :error-messages='error.filler_metal_other'
            label="Filler Metal Other"
            placeholder="Filler Metal Other"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Flux</label>
          <v-radio-group v-model="weldingProcedure.flux" row>
            <v-radio label="Yes" :value="1" class="mt-0"></v-radio>
            <v-radio label="No" :value="0" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.electrode_flux'
            :error-messages='error.electrode_flux'
            label='Electrode Flux'
            placeholder='Electrode Flux'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.shielding_gas'
            :error-messages='error.shielding_gas'
            label='Shielding Gas'
            placeholder='Shielding Gas'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.composition_per'
            :error-messages='error.composition_per'
            label='Composition Per'
            placeholder='Composition Per'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.flow_rate'
            :error-messages='error.flow_rate'
            label='Flow Rate'
            placeholder='Flow Rate'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.nozzle_size'
            :error-messages='error.nozzle_size'
            label='Nozzle Size'
            placeholder='Nozzle Size'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.gas_backing'
            :error-messages='error.gas_backing'
            label='Gas Backing'
            placeholder='Gas Backing'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.trailing_shielding_gas'
            :error-messages='error.trailing_shielding_gas'
            label='Trailing Shielding Gas'
            placeholder='Trailing Shielding Gas'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.gas_cup_size'
            :error-messages='error.gas_cup_size'
            label='Gas Cup Size'
            placeholder='Gas Cup Size'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.position_of_groove'
            :error-messages='error.position_of_groove'
            label='Position Of Groove'
            placeholder='Position Of Groove'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.position_of_fillet'
            :error-messages='error.position_of_fillet'
            label='Position Of Fillet'
            placeholder='Position Of Fillet'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.welding_progression'
            :error-messages='error.welding_progression'
            label='Welding Progression'
            placeholder='Welding Progression'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.tungsten_type'
            :error-messages='error.tungsten_type'
            label='Tungsten Type'
            placeholder='Tungsten Type'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.tungsten_size'
            :error-messages='error.tungsten_size'
            label='Tungsten Size'
            placeholder='Tungsten Size'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.torch_angle'
            :error-messages='error.torch_angle'
            label='Torch Angle'
            placeholder='Torch Angle'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.current'
            :error-messages='error.current'
            label='Current'
            placeholder='Current'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.mode_of_metal_transfer'
            :error-messages='error.mode_of_metal_transfer'
            label='Mode Of Metal Transfer'
            placeholder='Mode Of Metal Transfer'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-textarea
            v-model="weldingProcedure.electrical_char_remark"
            :error-messages='error.electrical_char_remark'
            label="Electrical Char Remark"
            placeholder="Electrical Char Remark"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.preheat_temperature_min'
            :error-messages='error.preheat_temperature_min'
            label='Preheat Temperature Min'
            placeholder='Preheat Temperature Min'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.preheat_temperature_max'
            :error-messages='error.preheat_temperature_max'
            label='Preheat Temperature Max'
            placeholder='Preheat Temperature Max'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.interpass_temperature_min'
            :error-messages='error.interpass_temperature_min'
            label='Interpass Temperature Min'
            placeholder='Interpass Temperature Min'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.interpass_temperature_max'
            :error-messages='error.interpass_temperature_max'
            label='Interpass Temperature Max'
            placeholder='Interpass Temperature Max'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-textarea
            v-model="weldingProcedure.preheat_maintenance"
            :error-messages='error.preheat_maintenance'
            label="Preheat Maintenance"
            placeholder="Preheat Maintenance"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.postheat_temperature_min'
            :error-messages='error.postheat_temperature_min'
            label='Postheat Temperature Min'
            placeholder='Postheat Temperature Min'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.postheat_temperature_max'
            :error-messages='error.postheat_temperature_max'
            label='Postheat Temperature Max'
            placeholder='Postheat Temperature Max'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.time_min'
            :error-messages='error.time_min'
            label='Time Min'
            placeholder='Time Min'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.time_max'
            :error-messages='error.time_max'
            label='Time Max'
            placeholder='Time Max'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-textarea
            v-model="weldingProcedure.postheat_remark"
            :error-messages='error.postheat_remark'
            label="Postheat Remark"
            placeholder="Postheat Remark"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.oscillation'
            :error-messages='error.oscillation'
            label='Oscillation'
            placeholder='Oscillation'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.weave_width'
            :error-messages='error.weave_width'
            label='Weave Width'
            placeholder='Weave Width'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.dwell_time'
            :error-messages='error.dwell_time'
            label='Dwell Time'
            placeholder='Dwell Time'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.weave_bead'
            :error-messages='error.weave_bead'
            label='Weave Bead'
            placeholder='Weave Bead'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.electrode'
            :error-messages='error.electrode'
            label='Electrode'
            placeholder='Electrode'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.electrode_spacing'
            :error-messages='error.electrode_spacing'
            label='Electrode Spacing'
            placeholder='Electrode Spacing'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.pass_perside'
            :error-messages='error.pass_perside'
            label='Pass Perside'
            placeholder='Pass Perside'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.cleaning'
            :error-messages='error.cleaning'
            label='Cleaning'
            placeholder='Cleaning'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.peening'
            :error-messages='error.peening'
            label='Peening'
            placeholder='Peening'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.contact_tube_work_distance'
            :error-messages='error.contact_tube_work_distance'
            label='Contact Tube Work Distance'
            placeholder='Contact Tube Work Distance'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.prepared_by'
            :error-messages='error.prepared_by'
            label='Prepared By'
            placeholder='Select Prepared By'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="weldingProcedure.prepared_date"
            :error-messages="error.prepared_date"
            type="date"
            label="Prepared Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='weldingProcedure.approved_by'
            :error-messages='error.approved_by'
            label='Approved By'
            placeholder='Select Approved By'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="weldingProcedure.approved_date"
            :error-messages="error.approved_date"
            type="date"
            label="Approved Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="weldingProcedure.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <h4>Base Metals</h4><hr>
      <v-row v-if="error.base_metal ? error.base_metal[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.base_metal ? error.base_metal[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in weldingProcedure.base_metal" :key="index" class="pt-5">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Base Metal"
                placeholder="Base Metal"
                v-model="weldingProcedure.base_metal[index].base_metal"
                :error-messages="error[`base_metal.${index}.base_metal`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Name / Grade"
                placeholder="Name / Grade"
                v-model="weldingProcedure.base_metal[index].grade"
                :error-messages="error[`base_metal.${index}.grade`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Material Specification"
                placeholder="Material Specification"
                v-model="weldingProcedure.base_metal[index].material_specification"
                :error-messages="error[`base_metal.${index}.material_specification`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="P No"
                placeholder="P No"
                v-model="weldingProcedure.base_metal[index].p_no"
                :error-messages="error[`base_metal.${index}.p_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Group No"
                placeholder="Group No"
                v-model="weldingProcedure.base_metal[index].group_no"
                :error-messages="error[`base_metal.${index}.group_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Thickness"
                placeholder="Thickness"
                v-model="weldingProcedure.base_metal[index].thickness"
                :error-messages="error[`base_metal.${index}.thickness`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Groove Thickness Range"
                placeholder="Groove Thickness Range"
                v-model="weldingProcedure.base_metal[index].groove_thickness_range"
                :error-messages="error[`base_metal.${index}.groove_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Fillet Thickness Range"
                placeholder="Fillet Thickness Range"
                v-model="weldingProcedure.base_metal[index].fillet_thickness_range"
                :error-messages="error[`base_metal.${index}.fillet_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Pipe Diameter Range"
                placeholder="Pipe Diameter Range"
                v-model="weldingProcedure.base_metal[index].pipe_diameter_range"
                :error-messages="error[`base_metal.${index}.pipe_diameter_range`]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4>Filler Metal</h4><hr>
      <v-row v-if="error.filler_metal ? error.filler_metal[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.filler_metal ? error.filler_metal[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, ind) in weldingProcedure.filler_metal" :key="`filler_metal_${ind}`" class="pt-5">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <searchable-select :value.sync="weldingProcedure.filler_metal[ind].welding_process_id" :options="{ url: 'welding_process', label: 'Welding Process' }" :errorMessage="error[`filler_metal.${ind}.welding_process_id`]" :selectedData="bindWeldingProcess(ind)" :key="ind"/>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
              label="F no"
              placeholder="F no"
              v-model="weldingProcedure.filler_metal[ind].f_no"
              :error-messages="error[`filler_metal.${ind}.f_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="A no"
              placeholder="A no"
              v-model="weldingProcedure.filler_metal[ind].a_no"
              :error-messages="error[`filler_metal.${ind}.a_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Spec No"
              placeholder="Spec No"
              v-model="weldingProcedure.filler_metal[ind].spec_no"
              :error-messages="error[`filler_metal.${ind}.spec_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Aws Class"
              placeholder="Aws Class"
              v-model="weldingProcedure.filler_metal[ind].aws_class"
              :error-messages="error[`filler_metal.${ind}.aws_class`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Filler Size"
              placeholder="Filler Size"
              v-model="weldingProcedure.filler_metal[ind].filler_size"
              :error-messages="error[`filler_metal.${ind}.filler_size`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Deposited Weld Metal Thickness"
              placeholder="Deposited Weld Metal Thickness"
              v-model="weldingProcedure.filler_metal[ind].deposited_weld_metal_thickness"
              :error-messages="error[`filler_metal.${ind}.deposited_weld_metal_thickness`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Groove"
              placeholder="Groove"
              v-model="weldingProcedure.filler_metal[ind].groove"
              :error-messages="error[`filler_metal.${ind}.groove`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Fillet"
              placeholder="Fillet"
              v-model="weldingProcedure.filler_metal[ind].fillet"
              :error-messages="error[`filler_metal.${ind}.fillet`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Electrode Flux Class"
              placeholder="Electrode Flux Class"
              v-model="weldingProcedure.filler_metal[ind].electrode_flux_class"
              :error-messages="error[`filler_metal.${ind}.electrode_flux_class`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-textarea
              v-model="weldingProcedure.filler_metal[ind].remarks"
              :error-messages='error[`filler_metal.${ind}.remarks`]'
              label="Remarks"
              placeholder="Remarks"
              rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon @click="removeFillerMetal(ind)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
              <v-btn @click="removeFillerMetal(ind)" small block v-else>Delete</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addFillerMetal" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <h4>Weldinig Parameters</h4><hr>
      <v-row v-if="error.welding_parameter ? error.welding_parameter[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.welding_parameter ? error.welding_parameter[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, ind) in weldingProcedure.welding_parameter" :key="`welding_parameter_${ind}`" class="pt-5">
          <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="weldingProcedure.welding_parameter[ind].welding_process_id" :options="{ url: 'welding_process', label: 'Welding Process' }" :errorMessage="error[`welding_parameter.${ind}.welding_process_id`]" :selectedData="bindWpmWeldingProcess(ind)" :key="ind"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <v-text-field
                label="Weld Layer"
                placeholder="Weld Layer"
                v-model="weldingProcedure.welding_parameter[ind].weld_layer"
                :error-messages="error[`welding_parameter.${ind}.weld_layer`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Class"
                placeholder="Filler Class"
                v-model="weldingProcedure.welding_parameter[ind].filler_class"
                :error-messages="error[`welding_parameter.${ind}.filler_class`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Size"
                placeholder="Filler Size"
                v-model="weldingProcedure.welding_parameter[ind].filler_size"
                :error-messages="error[`welding_parameter.${ind}.filler_size`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="weldingProcedure.welding_parameter[ind].polarity_id" :options="{ url: 'polarity', label: 'Polarity' }" :errorMessage="error[`welding_parameter.${ind}.polarity_id`]" :selectedData="bindWpmPolarity(ind)" :key="ind" :disabled="weldingProcedure.welding_parameter[ind].id !== undefined ? true : false"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Current"
                placeholder="Min Current"
                v-model="weldingProcedure.welding_parameter[ind].min_current"
                :error-messages="error[`welding_parameter.${ind}.min_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Current"
                placeholder="Max Current"
                v-model="weldingProcedure.welding_parameter[ind].max_current"
                :error-messages="error[`welding_parameter.${ind}.max_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Voltage"
                placeholder="Min Voltage"
                v-model="weldingProcedure.welding_parameter[ind].min_voltage"
                :error-messages="error[`welding_parameter.${ind}.min_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Voltage"
                placeholder="Max Voltage"
                v-model="weldingProcedure.welding_parameter[ind].max_voltage"
                :error-messages="error[`welding_parameter.${ind}.max_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Travel Speed"
                placeholder="Min Travel Speed"
                v-model="weldingProcedure.welding_parameter[ind].min_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.min_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Travel Speed"
                placeholder="Max Travel Speed"
                v-model="weldingProcedure.welding_parameter[ind].max_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.max_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Feed Speed"
                placeholder="Min Feed Speed"
                v-model="weldingProcedure.welding_parameter[ind].min_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.min_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Feed Speed"
                placeholder="Max Feed Speed"
                v-model="weldingProcedure.welding_parameter[ind].max_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.max_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Flow Rate"
                placeholder="Min Flow Rate"
                v-model="weldingProcedure.welding_parameter[ind].min_flowrate"
                :error-messages="error[`welding_parameter.${ind}.min_flowrate`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Flow Rate"
                placeholder="Max Flow Rate"
                v-model="weldingProcedure.welding_parameter[ind].max_flowrate"
                :error-messages="error[`welding_parameter.${ind}.max_flowrate`]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon @click="removeWeldingParameter(ind)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
                <v-btn @click="removeWeldingParameter(ind)" small block v-else>Delete</v-btn>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addWeldingParameter" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.$axios.post('getWeldingProcedureById/' + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        this.weldingProcedure = data
        setTimeout(() => {
          this.weldingProcedure.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
          const l = this.weldingProcedure.filler_metal.length
          this.weldingProcedure.filler_metal.splice((l - 1), 1)
          this.weldingProcedure.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' })
          const l1 = this.weldingProcedure.welding_parameter.length
          this.weldingProcedure.welding_parameter.splice((l1 - 1), 1)
        }, 1000)
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
    this.weldingProcedure.base_metal.push(
      { base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' },
      { base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' }
    )
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      weldingProcedure: { status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], filler_metal: [], welding_parameter: [] },
      error: {},
    }
  },
  methods: {
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveWeldingProcedure/' + this.edit_id : 'saveWeldingProcedure'
        this.$axios.post(route, this.weldingProcedure).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/weldingProcedure')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createWeldingProcedureForm.validate()
      }
    },
    reset () {
      this.$refs.createWeldingProcedureForm.reset()
      setTimeout(() => {
        this.weldingProcedure = { status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], filler_metal: [], welding_parameter: [] }
        this.error = {}
        // this.$refs.firstInput.focus()
      }, 300)
    },
    addFillerMetal () {
      this.weldingProcedure.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
    },
    removeFillerMetal (index) {
      this.weldingProcedure.filler_metal.splice(index, 1)
    },
    bindWeldingProcess (ind) {
      const bindFiller = {}
      bindFiller.id = this.weldingProcedure.filler_metal[ind].wps_id
      bindFiller.text = this.weldingProcedure.filler_metal[ind].wps_text
      return bindFiller
    },
    addWeldingParameter () {
      this.weldingProcedure.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' })
    },
    removeWeldingParameter (ind) {
      this.weldingProcedure.welding_parameter.splice(ind, 1)
    },
    bindWpmWeldingProcess (ind) {
      const wpmWeldingProcess = {}
      wpmWeldingProcess.id = this.weldingProcedure.welding_parameter[ind].wpm_wps_id
      wpmWeldingProcess.text = this.weldingProcedure.welding_parameter[ind].wpm_wps_text
      return wpmWeldingProcess
    },
    bindWpmPolarity (ind) {
      const wpmPolarity = {}
      wpmPolarity.id = this.weldingProcedure.welding_parameter[ind].wpm_plr_id
      wpmPolarity.text = this.weldingProcedure.welding_parameter[ind].wpm_plr_text
      return wpmPolarity
    },
  },
}
</script>

<style>
.createWeldingProcedureForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createWeldingProcedureForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
